import { Location } from 'history';
import React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { match, RouteComponentProps } from 'react-router';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { AppState } from '../../app/state/AppState';

export interface PredictiveModelRouteParams {
  readonly id: string;
}

export interface PredictiveModelRouteComponentProps extends RouteComponentProps<PredictiveModelRouteParams> {
  readonly match: match<PredictiveModelRouteParams>;
  readonly location: Location;
}

export interface PredictiveModelSpaceRouterOwnProps {
  readonly siteName: string;
  readonly previousUrl: string;
  readonly urls: SpacesSiteUrls;
}

export interface PredictiveModelSpaceRouterStateProps {
  readonly isRequestAccessEnabled: boolean;
}

export type PredictiveModelSpaceRouterProps =
  PredictiveModelRouteComponentProps &
  PredictiveModelSpaceRouterOwnProps &
  PredictiveModelSpaceRouterStateProps;

export class PredictiveModelSpaceRouterComponent extends React.Component<PredictiveModelSpaceRouterProps, {}> {
  public render() {
    return (
      //TODO - lschmidt TFSID 1333772: Finish the implementation of PredictiveModelSpaceRouterComponent
      <></>
    );
  }
}

const mapStateToProps: MapStateToProps<PredictiveModelSpaceRouterStateProps, PredictiveModelSpaceRouterOwnProps, {}> = (state: AppState) => ({
  isRequestAccessEnabled: SessionSiteSelectors.isRequestAccessEnabled(state)
});

export const PredictiveModelSpaceRouter: React.ComponentClass<PredictiveModelSpaceRouterOwnProps>
  = connect(mapStateToProps, null, null, { pure: false })(PredictiveModelSpaceRouterComponent);
